import { ApiService } from './api/api'

export default class LanguagesService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all document types
	 * @returns Promise
	 */
	getAll(): Promise<any> {
		return this.apiService.get(`/languages`)
	}
}
